// extracted by css-extract-rspack-plugin
export default {"ellipsisRow":"CodeFoldingEllipsisOverlay-module__ellipsisRow__Z5MC7"};